/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Own_CodeInputs */

const en_friends_own_code = /** @type {(inputs: Friends_Own_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That’s your own code.`)
};

const de_friends_own_code = /** @type {(inputs: Friends_Own_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist euer eigener Code.`)
};

/**
* | output |
* | --- |
* | "That’s your own code." |
*
* @param {Friends_Own_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_own_code = /** @type {((inputs?: Friends_Own_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Own_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_own_code(inputs)
	return en_friends_own_code(inputs)
});